var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _vm._m(0)}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"trial-success-wrap"},[_c('img',{attrs:{"src":"/static/images/contact.png","alt":""}}),_vm._v(" "),_c('p',[_vm._v("提交成功，我们将在三个工作日内联系您")])])}]
export { render, staticRenderFns }


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-0804dece","hasScoped":false,"optionsId":"0","buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/ApplyTrialSuccess.vue
// module id = null
// module chunks = 